import { Star } from 'lucide-react'
import { SessionManager } from 'utils'

export default function ActionReviews(props) {

    const { text, route_name, onClick } = props

    var permission = JSON.parse(SessionManager.getSession('permission'))

    return (
        <>
            {permission?.some(val => val.sub_action_name === route_name) &&
                <Star size={16} className='action_btn reviews_btn text-secondary me-3'
                    onClick={onClick}
                    data-tooltip-id='global-tooltip'
                    data-tooltip-content={text}
                    data-tooltip-place="bottom"
                    data-tooltip-class-name='tl_amber tooltip_msg'
                />
            }
        </>
    )
}